<template>
    <!--h4 class="text-success text-center my-2">Api integrated</h4-->


    <div class="px-2 mx-auto d-flex justify-content-center flex-column gap-4" v-if="loading">
        <CardLoader />
        <CardLoader />
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center p-5" v-else>
        <!-- Page Heading -->
        <div class="dashboard-heading mb-4" style="width: 100%;">
            <div class="dh-icon-wrap dh-icon-location">
                <i class="material-icons">location_on</i>
            </div>
            <div>
                <h5 class="dh-title">Edit Location</h5>
                <p class="dh-subtitle">{{ location.name || 'Loading...' }}</p>
            </div>
            <a v-if="canSeeEditOrganization" class="dh-nav-link ms-auto" @click.prevent="goToEditOrganization">
                <i class="material-icons" style="font-size:18px;">business</i>
                Edit Organization
            </a>
        </div>

        <div class="d-flex justify-content-end" style="width: 100%;">
            <ExplainPageButton page-key="location" />
        </div>

        <label class="text-lg text-info text-right cursor-pointer pt-2 d-flex align-items-center gap-2"
            @click="openModal">
            <i class="material-icons text-2xl text-info">info</i>
            What's Next ?</label>
        <ContentContainer>
            <template v-slot:content>
                <div class="row d-flex align-items-center m-auto px-2">
                    <div v-for="item in additionalPages" :key="item.id || item.name" class="col-lg-4 col-md-5 col-12 d-flex">
                        <TabCard 
                            class="flex-fill my-5" 
                            :text="item.name" 
                            :detail="item.description"
                            :icon="getCardIcon(item.name)"
                            @click="redirectToPage(item)" 
                        />
                    </div>
                </div>
            </template>

        </ContentContainer>

        <div class="my-4" style="width: 100%;">
            <FormContainer heading="Edit Location">
                <template v-slot:content>
                    <form @submit.prevent="saveOrganization">
                        <div class="row">
                            <!-- ID -->
                            <div class="col-md-6 mb-3">
                                <material-input id="id" type="text" label="ID" name="id" v-model="location.id"
                                    :read-only="true" />
                            </div>
                            <!-- Name -->
                            <div class="col-md-6 mb-3">
                                <material-input id="name" type="text" label="Name" name="name"
                                    v-model="location.name" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Description -->
                            <div class="col-12 mb-3">
                                <material-input id="description" type="text" label="Description" name="description"
                                    v-model="location.description" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Email -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Email</label>
                                    <HelpTextTooltip helpKey="location_detail_email" />
                                </div>
                                <material-input id="email" type="email" name="email"
                                    v-model="location.email" :error="!!emailError" @blur="validateEmail" />
                                <small v-if="emailError" class="text-danger">{{ emailError }}</small>
                            </div>
                            <!-- Phone -->
                            <div class="col-md-6 mb-3">
                                <material-input id="phone" type="tel" label="Phone Number" name="phone"
                                    v-model="location.phone" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Priority -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Location Priority</label>
                                    <HelpTextTooltip helpKey="location_detail_priority" />
                                </div>
                                <MaterialSpinnerInput id="priority" v-model="location.priority" :min="0" />
                            </div>
                            <!-- Status -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Status</label>
                                    <HelpTextTooltip helpKey="location_detail_status" />
                                </div>
                                <MaterialSelect id="status" name="status"
                                    v-model="location.status" :options="statusOptions" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Display Ads -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Display Bible based content</label>
                                    <HelpTextTooltip helpKey="location_detail_showads" />
                                </div>
                                <MaterialSelect id="displayAds" name="displayAds"
                                    v-model="location.displayAds"
                                    :options="yesNoOptions"
                                     />
                            </div>
                            <!-- Display Inspirational Messages -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Display Inspirational Messages</label>
                                    <HelpTextTooltip helpKey="location_detail_showinspirations" />
                                </div>
                                <MaterialSelect id="displayMessages"
                                    name="displayMessages" v-model="location.displayMessages"
                                    :options="yesNoOptions" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- User self register -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">User Self Register</label>
                                    <HelpTextTooltip helpKey="location_detail_selfregister" />
                                </div>
                                <MaterialSelect id="userRegister" name="userRegister"
                                    v-model="location.userRegister"
                                    :options="yesNoOptions" />
                            </div>
                            <!-- Users can view schedules -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Users can view All Schedules</label>
                                    <HelpTextTooltip helpKey="location_detail_viewsched" />
                                </div>
                                <MaterialSelect id="viewSchedules"
                                    name="viewSchedules" v-model="location.viewSchedules"
                                    :options="yesNoOptions" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Allow volunteers to create People Groups</label>
                                    <HelpTextTooltip helpKey="location_detail_allow_volunteer_group_creation" />
                                </div>
                                <MaterialSelect id="allowVolunteerGroupCreation" name="allowVolunteerGroupCreation"
                                    v-model="location.allowVolunteerGroupCreation"
                                    :options="yesNoOptions" />
                                <small class="form-text text-muted">
                                    When enabled, volunteers can create groups for coordinating family assignments.
                                </small>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Join Organization search visibility -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Show location in Join Organization search</label>
                                    <HelpTextTooltip helpKey="location_detail_searchable" />
                                </div>
                                <MaterialSelect id="searchable" name="searchable"
                                    v-model="location.searchable"
                                    :options="yesNoOptions" />
                                <small class="form-text text-muted">
                                    When disabled, nonmembers won't see this location in search results.
                                </small>
                            </div>
                        </div>

                        <div class="row">
                            <!-- Non-admin users can choose activities -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Non-admin users can choose Activities/Workgroups</label>
                                    <HelpTextTooltip helpKey="location_detail_prefactwg" />
                                </div>
                                <MaterialSelect id="userpreferredoptions"
                                    name="userpreferredoptions"
                                    v-model="location.userpreferredoptions"
                                    :options="yesNoOptions" />
                            </div>
                            <!-- Enable reminders -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Enable Reminders (SMS, Email)</label>
                                    <HelpTextTooltip helpKey="location_detail_enablereminders" />
                                </div>
                                <MaterialSelect id="enableReminders"
                                    name="enableReminders" v-model="location.enableReminders"
                                    :options="yesNoOptions" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Enable AI chat -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="enable_ai_chat" label="Enable AI chat feature"
                                    name="enable_ai_chat" :checked="location.enable_ai_chat"
                                    @change="location.enable_ai_chat = $event.target.checked" />
                            </div>
                            <!-- Enable AI schedule generation -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="enable_ai_schedulegeneration" label="Enable AI schedule generation feature"
                                    name="enable_ai_schedulegeneration" :checked="location.enable_ai_schedulegeneration"
                                    @change="location.enable_ai_schedulegeneration = $event.target.checked" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="volunteer_invites_enabled"
                                    label="Allow volunteers to invite others to serve"
                                    name="volunteer_invites_enabled"
                                    :checked="location.volunteerInvitesEnabled"
                                    @change="location.volunteerInvitesEnabled = $event.target.checked" />
                                <small class="form-text text-muted">Volunteers can invite friends to serve in a suggested skill or explore serving in general.</small>
                            </div>
                        </div>

                        <div class="row">
                            <!-- Auto-Scheduler completion notification -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Auto-Scheduler Notification</label>
                                    <HelpTextTooltip helpKey="location_detail_autocomplete" />
                                </div>
                                <MaterialSelect id="autoScheduler"
                                    name="autoScheduler" v-model="location.autoScheduler" :options="yesNoOptions" />
                            </div>
                            <!-- Send Admin Report -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Send Admin Report</label>
                                    <HelpTextTooltip helpKey="location_detail_send_admin_report" />
                                </div>
                                <MaterialSelect id="sendAdminReport"
                                    name="sendAdminReport" v-model="location.sendAdminReport" :options="yesNoOptions" />
                            </div>
                        </div>
                        <div class="row">
                            <!-- Periodic Location admin report weekday -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Send Admin Report Day</label>
                                    <HelpTextTooltip helpKey="location_detail_send_admin_report_day" />
                                </div>
                                <MaterialSelect id="sendAdminReportDay" name="sendAdminReportDay"
                                    v-model="location.sendAdminReportDay" :options="sendAdminReportDayOptions" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- TimeZone -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="timezone" label="Time Zone" name="timezone"
                                    v-model="location.timezone" :options="timezonesOptions" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Country -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="country" label="Country" name="country" :options="countriesOptions"
                                    v-model="location.country" />
                            </div>
                            <!-- Default Skill -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Default Skill</label>
                                    <HelpTextTooltip helpKey="location_detail_defaultskill" />
                                </div>
                                <MaterialSelect id="defaultSkill" type="text" name="defaultSkill"
                                    :options="allSkills" v-model="location.defaultSkill" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Default View Mode -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Default View Mode</label>
                                    <HelpTextTooltip helpKey="location_detail_defaultviewmode" />
                                </div>
                                <MaterialSelect id="viewMode" name="viewMode"
                                    :options="viewModeOptions" v-model="location.viewMode" />
                            </div>
                            <!-- Send SMS/Text -->
                            <div class="col-md-6 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Send SMS/Text X days before each instance date</label>
                                    <HelpTextTooltip helpKey="location_detail_sendsmsdays" />
                                </div>
                                <MaterialSpinnerInput id="sendSmsDays" v-model="location.sendSmsDays" :min="0" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Do not send Volunteer E-mail reminders on -->
                            <div class="col-12 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Do not send Volunteer E-mail reminders on</label>
                                    <HelpTextTooltip helpKey="location_detail_excludeemaildays" />
                                </div>
                                <div class="d-flex gap-5 flex-wrap">
                                    <MaterialSwitch v-for="day in weekDays" :key="day.value" :id="day.value"
                                        :name="day.value" :label="day.label"
                                        :checked="location.noEmailDays.includes(day.value)"
                                        @change="toggleDay(day.value)" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <!-- URLs -->
                            <div class="col-md-4 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Location Website URL</label>
                                    <HelpTextTooltip helpKey="location_detail_locurl" />
                                </div>
                                <material-input id="websiteUrl" type="text"
                                    name="websiteUrl" v-model="location.websiteUrl" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Custom URL</label>
                                    <HelpTextTooltip helpKey="location_detail_customurl" />
                                </div>
                                <material-input id="customUrl" type="text" name="customUrl"
                                    v-model="location.customUrl" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Custom Login URL</label>
                                    <HelpTextTooltip helpKey="location_detail_customloginurl" />
                                </div>
                                <material-input id="loginUrl" type="text" name="loginUrl"
                                    v-model="location.loginUrl" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Embeddable public "All Schedules" URL -->
                            <div class="col-12 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">All Schedules URL (embed on your website)</label>
                                    <HelpTextTooltip helpKey="location_detail_allschedulesurl" />
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                    <material-input id="allSchedulesUrl" type="text" name="allSchedulesUrl"
                                        :modelValue="allSchedulesUrl" :read-only="true" class="flex-grow-1" />
                                    <MaterialButton type="button" variant="secondary" class="px-3"
                                        title="Copy URL" :disabled="!allSchedulesUrl" @click="copyAllSchedulesUrl">
                                        <i class="material-icons text-lg">content_copy</i>
                                    </MaterialButton>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <!-- Location-specific public signup URL -->
                            <div class="col-12 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Custom Sign Up URL</label>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                    <material-input id="customSignUpUrl" type="text" name="customSignUpUrl"
                                        :modelValue="signUpUrl" :read-only="true" class="flex-grow-1" />
                                    <MaterialButton type="button" variant="secondary" class="px-3"
                                        title="Copy URL" :disabled="!signUpUrl" @click="copySignUpUrl">
                                        <i class="material-icons text-lg">content_copy</i>
                                    </MaterialButton>
                                </div>
                                <small v-if="!signUpUrl || !allSchedulesUrl" class="text-danger">
                                    Public links are unavailable. Please reload or contact an administrator.
                                </small>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Last Admin Report Date -->
                            <div class="col-12 mb-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                    <label class="form-label mb-0">Last Admin Report Date</label>
                                    <HelpTextTooltip helpKey="location_detail_reportdate" />
                                </div>
                                <material-input id="lastReportDate" type="text"
                                    name="lastReportDate" v-model="location.lastReportDate" :read-only="true" />
                            </div>
                        </div>

                        <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                                <MaterialButton type="submit" variant="primary" class="px-4" :disabled="isSaving"
                                    :class="{ 'btn-pulse': hasChanges && !isSaving }">
                                    <span v-if="isSaving" class="spinner-border spinner-border-sm me-2" role="status"
                                        aria-hidden="true"></span>
                                    <i v-else class="material-icons text-lg me-1">save</i>
                                    {{ isSaving ? 'Saving...' : 'Save' }}
                                </MaterialButton>
                            </div>
                        </div>
                    </form>
                </template>
            </FormContainer>
        </div>

        <!-- Registration Details (superadmin only) -->
        <div v-if="isSuperAdmin" class="my-4" style="width: 100%;">
            <FormContainer heading="Registration Details">
                <template v-slot:content>
                    <div v-if="location.signUpContext" class="text-sm"
                        style="white-space: pre-wrap; overflow-wrap: anywhere;">{{ location.signUpContext }}</div>
                    <p v-else class="text-muted mb-0">No Registration Details were recorded for this Location.</p>
                </template>
            </FormContainer>
        </div>

        <!-- Monthly Cost Limits Card -->
        <div class="my-4" style="width: 100%;">
            <FormContainer>
                <template v-slot:content>
                    <div class="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                        <h4 class="mb-0">Monthly Cost Limits</h4>
                        <span class="cost-limit-info-icon" title="These limits control maximum monthly spending per feature. When a limit is reached, the feature is automatically disabled until the next month or until an admin increases the limit.">
                            <i class="material-icons" style="font-size:20px; color:#7b809a; cursor:help;">info_outline</i>
                        </span>
                    </div>


                    <!-- AI Chat -->
                    <div class="cost-slider-row mb-4">
                        <div class="cost-slider-header">
                            <div>
                                <label class="cost-slider-label">AI Chat Monthly Limit</label>
                                <p class="cost-slider-subtitle">Controls Ezer AI chatbot usage</p>
                            </div>
                            <span class="cost-slider-value cost-slider-value--blue">
                                {{ location.monthly_ai_chat_cost_limit === 0 ? 'Unlimited' : '$' + Number(location.monthly_ai_chat_cost_limit).toFixed(2) }}
                            </span>
                        </div>
                        <div class="cost-slider-track-wrap">
                            <span class="cost-slider-minmax">$0</span>
                            <input type="range" class="cost-slider cost-slider--blue" min="0" max="200" step="5"
                                v-model.number="location.monthly_ai_chat_cost_limit" />
                            <span class="cost-slider-minmax">$200</span>
                        </div>
                    </div>

                    <!-- AI Schedule Generation -->
                    <div class="cost-slider-row mb-4">
                        <div class="cost-slider-header">
                            <div>
                                <label class="cost-slider-label">AI Schedule Generation Monthly Limit</label>
                                <p class="cost-slider-subtitle">Controls AI-powered schedule generation</p>
                            </div>
                            <span class="cost-slider-value cost-slider-value--purple">
                                {{ location.monthly_ai_schedulegeneration_cost_limit === 0 ? 'Unlimited' : '$' + Number(location.monthly_ai_schedulegeneration_cost_limit).toFixed(2) }}
                            </span>
                        </div>
                        <div class="cost-slider-track-wrap">
                            <span class="cost-slider-minmax">$0</span>
                            <input type="range" class="cost-slider cost-slider--purple" min="0" max="500" step="5"
                                v-model.number="location.monthly_ai_schedulegeneration_cost_limit" />
                            <span class="cost-slider-minmax">$500</span>
                        </div>
                    </div>

                    <!-- SMS -->
                    <div class="cost-slider-row mb-4">
                        <div class="cost-slider-header">
                            <div>
                                <label class="cost-slider-label">SMS Monthly Limit</label>
                                <p class="cost-slider-subtitle">Controls SMS/text message spending</p>
                            </div>
                            <span class="cost-slider-value cost-slider-value--green">
                                {{ location.monthly_sms_cost_limit === 0 ? 'Unlimited' : '$' + Number(location.monthly_sms_cost_limit).toFixed(2) }}
                            </span>
                        </div>
                        <div class="cost-slider-track-wrap">
                            <span class="cost-slider-minmax">$0</span>
                            <input type="range" class="cost-slider cost-slider--green" min="0" max="500" step="5"
                                v-model.number="location.monthly_sms_cost_limit" />
                            <span class="cost-slider-minmax">$500</span>
                        </div>
                    </div>

                    <!-- Overall Monthly Spend Limit -->
                    <div class="cost-slider-row" style="border: 2px solid #ed6c02; background: #fff8f0;">
                        <div class="cost-slider-header">
                            <div>
                                <label class="cost-slider-label">Overall Monthly Location Spend Limit</label>
                                <p class="cost-slider-subtitle">Maximum total monthly spending across all features. Set to $0 for unlimited.</p>
                            </div>
                            <span class="cost-slider-value cost-slider-value--orange">
                                {{ location.monthly_spend_limit === 0 ? 'Unlimited' : '$' + Number(location.monthly_spend_limit).toFixed(2) }}
                            </span>
                        </div>
                        <div class="cost-slider-track-wrap">
                            <span class="cost-slider-minmax">$0</span>
                            <input type="range" class="cost-slider cost-slider--orange" min="0" max="2000" step="25"
                                v-model.number="location.monthly_spend_limit" />
                            <span class="cost-slider-minmax">$2k</span>
                        </div>
                    </div>

                    <!-- Save button for cost limits -->
                    <div class="d-flex justify-content-end mt-4 pt-3 border-top">
                        <MaterialButton variant="primary" class="px-4" :disabled="isSaving"
                            :class="{ 'btn-pulse': hasChanges && !isSaving }" @click="saveOrganization">
                            <span v-if="isSaving" class="spinner-border spinner-border-sm me-2" role="status"
                                aria-hidden="true"></span>
                            <i v-else class="material-icons text-lg me-1">save</i>
                            {{ isSaving ? 'Saving...' : 'Save Cost Limits' }}
                        </MaterialButton>
                    </div>
                </template>
            </FormContainer>
        </div>

        <div class="my-4" style="width: 100%;">
            <FormContainer heading="Select Admins for this location">
                <template v-slot:content>
                    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="All Users"
                        selectedOptionsHeading="Current Admins" :initial-skills="allUsers"
                        v-model:interests="currentAdmins" :on-save="handleSaveInterests" :loading="loading" :show-default-message="false" />
                </template>
            </FormContainer>
        </div>
    </div>

    <ContentModal v-model="showModal" title="Setup Steps Checklist">
        <template #default>
            <div v-if="loadingSetupStatus" class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2">Loading setup status...</p>
            </div>

            <div v-else-if="setupStatus">
                <!-- Handle both old format (with steps) and new format (with items) -->
                <div v-if="setupStatus.complete || setupStatus.is_complete" class="alert alert-success d-flex align-items-center">
                    <i class="material-icons me-2">check_circle</i>
                    <span>{{ setupStatus.headline }}</span>
                </div>
                <div v-else class="alert alert-warning d-flex align-items-center">
                    <i class="material-icons me-2">warning</i>
                    <span>{{ setupStatus.headline }}</span>
                </div>

                <!-- New format with instructions and items -->
                <div>
                    <p class="fw-bold mt-3 mb-3">{{ setupStatus.instructions }}</p>
                    <ul class="ms-4">
                        <li v-for="(item, index) in setupStatus.items" :key="index" class="mb-2">
                            {{ item }}
                        </li>
                    </ul>
                </div>

                <!-- <div v-if="setupStatus.completion_percentage !== undefined" class="mt-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-semibold">Completion Progress</span>
                        <span class="fw-bold" :class="setupStatus.completion_percentage === 100 ? 'text-success' : 'text-warning'">
                            {{ setupStatus.completion_percentage }}%
                        </span>
                    </div>
                    <div class="progress" style="height: 20px;">
                        <div class="progress-bar" 
                            :class="setupStatus.completion_percentage === 100 ? 'bg-success' : 'bg-warning'"
                            :style="{ width: setupStatus.completion_percentage + '%' }"
                            role="progressbar" 
                            :aria-valuenow="setupStatus.completion_percentage" 
                            aria-valuemin="0" 
                            aria-valuemax="100">
                            {{ setupStatus.completion_percentage }}%
                        </div>
                    </div>
                </div> -->
            </div>

            <div v-else class="alert alert-danger">
                <i class="material-icons me-2">error</i>
                Failed to load setup status. Please try again.
            </div>
        </template>
    </ContentModal>
    <Modal v-if="isAdditionalModalOpen" :modalHeading="additionalModalHeading" :iframeUrl="additionalModalUrl"
        refresh-on-close @close="closeAdditionalModal" />
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MaterialInput from '@/components/common/MaterialInput.vue'
import MaterialButton from '@/components/common/MaterialButton.vue'
import MaterialSelect from '@/components/common/MaterialSelect.vue'
import MaterialSpinnerInput from '@/components/common/MaterialSpinnerInput.vue'
import ContentContainer from '@/components/PageLayout/ContentContainer.vue'
import TagSelector from '@/components/common/TagSelector.vue'
import MaterialSwitch from '@/components/common/MaterialSwitch.vue'
import TabCard from '@/components/Cards/TabCards.vue';
import FormContainer from '../../components/PageLayout/FormContainer.vue'
import ContentModal from '../../components/Modal/ContentModal.vue'
import Modal from '@/components/Modal/Modal.vue'
import HelpTextTooltip from '@/components/common/HelpTextTooltip.vue'
import ExplainPageButton from '@/components/common/ExplainPageButton.vue'
import { useStore } from 'vuex'
import { usePermissions } from '@/composables/usePermissions'
import CardLoader from '../../components/Loader/CardLoader.vue'
import api from '@/config/api'
import { useToast } from 'vue-toast-notification'
import { getOrganizationId } from '@/utils/SessionDataHandler'
import { isValidEmail } from '@/utils/validation'

const router = useRouter()
const route = useRoute()
const store = useStore()
const toast = useToast()
const { isSuperAdmin, isOrganizationAdmin } = usePermissions()
const canSeeEditOrganization = computed(() => isSuperAdmin.value || isOrganizationAdmin.value)
const locationId = route.params.locationID
const publicLinkTokens = ref(null)
const loggedPersonId = computed(() => store.getters.stSessionData?.personId || store.getters.stSessionData?.personid || '')

// Public, embeddable "All Schedules" URL for this location. Site owners can
// embed this on their website so visitors can view public schedules.
const allSchedulesUrl = computed(() => {
    if (!publicLinkTokens.value?.schedules) return ''
    const base = (process.env.VUE_APP_BASE_URL || window.location.origin).replace(/\/+$/, '')
    return `${base}/all-schedules/${encodeURIComponent(publicLinkTokens.value.schedules)}`
})
const signUpUrl = computed(() => {
    if (!publicLinkTokens.value?.signup) return ''
    const base = (process.env.VUE_APP_BASE_URL || window.location.origin).replace(/\/+$/, '')
    return `${base}/sign-up?locid=${encodeURIComponent(publicLinkTokens.value.signup)}`
})

function copyAllSchedulesUrl() {
    const url = allSchedulesUrl.value
    if (!url) return
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
            .then(() => toast.success('All Schedules URL copied to clipboard', { position: 'top-right' }))
            .catch(() => toast.error('Failed to copy URL', { position: 'top-right' }))
    } else {
        toast.info(url, { position: 'top-right' })
    }
}
function copySignUpUrl() {
    const url = signUpUrl.value
    if (!url) return
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
            .then(() => toast.success('Sign Up URL copied to clipboard', { position: 'top-right' }))
            .catch(() => toast.error('Failed to copy URL', { position: 'top-right' }))
    } else {
        toast.info(url, { position: 'top-right' })
    }
}

const loading = ref(false);
const isSaving = ref(false);

// const submitting = ref(false);

var showModal = ref(false);
const emailError = ref(null);

// const additionalPages = [
//     {
//         "name": "Add/edit Users and Volunteers",
//         "description": "Add volunteers to the database, assign the volunteers to specific skills",
//         "link": "/users/add-edit"
//     },
//     {
//         "name": "Download Users list",
//         "description": "Download existing Users list as a CSV file",
//         "link": "/users/download"
//     },
//     {
//         "name": "Create/edit Activities/Events",
//         "description": "Add Events/Services (e.g., 'Sunday Morning Service'), create workgroups and setup a recurring schedule",
//         "link": "/activities/create-edit"
//     },
//     {
//         "name": "Create/edit Skills/Roles",
//         "description": "Add additional skills (e.g., usher)",
//         "link": "/skills/create-edit"
//     },
//     {
//         "name": "Manage Schedules",
//         "description": "View schedules that have been generated",
//         "link": "/schedules/manage"
//     },
//     {
//         "name": "Pending Registrations",
//         "description": "Approve or deny pending registrations in this location",
//         "link": "/registrations/pending"
//     },
//     {
//         "name": "Send Message to Admins",
//         "description": "Send message to organizers or users with administrator privileges",
//         "link": "/messages/admins"
//     },
//     {
//         "name": "Activate DEMO",
//         "description": "Enables demo (creates demo skills, activity, test users; enables auto-scheduling and reminders for upcoming 4-week period)",
//         "link": "/demo/activate"
//     },
//     {
//         "name": "Activity Setup Wizard",
//         "description": "Easy process to setup activity, skills, workgroups, add users, etc.",
//         "link": "/wizard/activity-setup"
//     }
// ]


const additionalPages = ref([])
const isAdditionalModalOpen = ref(false);
const additionalModalUrl = ref('');
const additionalModalHeading = ref('');

const location = reactive({
    id: null,
    name: "",
    description: "",
    email: "",
    phone: "",
    priority: 0,
    status: "inactive",
    displayAds: "no",
    displayMessages: "no",
    userRegister: "no",
    allowVolunteerGroupCreation: "yes",
    searchable: "yes",
    viewSchedules: "no",
    userpreferredoptions: "no",
    enableReminders: "no",
    enable_ai_chat: false,
    enable_ai_schedulegeneration: false,
    volunteerInvitesEnabled: true,
    monthly_ai_chat_cost_limit: 30,
    monthly_ai_schedulegeneration_cost_limit: 50,
    monthly_sms_cost_limit: 50,
    monthly_spend_limit: 0,
    autoScheduler: "no",
    sendAdminReport: "no",
    sendAdminReportDay: "Thursday",
    timezone: "America/Chicago",
    country: "",
    defaultSkill: "",
    viewMode: "grid",
    sendSmsDays: 0,
    noEmailDays: [],
    websiteUrl: "",
    customUrl: "",
    loginUrl: "",
    lastReportDate: "",
    signUpContext: ""
})

const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
]

const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" }

]
const sendAdminReportDayOptions = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" }
]

// const viewModeOptions = [
//     { value: "grid", text: "Grid Edit Mode" },
//     { value: "list", text: "List View" }
// ]

const viewModeOptions = ref([])

const weekDays = [
    { value: "Mon", label: "Mon" },
    { value: "Tue", label: "Tue" },
    { value: "Wed", label: "Wed" },
    { value: "Thu", label: "Thu" },
    { value: "Fri", label: "Fri" },
    { value: "Sat", label: "Sat" },
    { value: "Sun", label: "Sun" }
]

// const allSkills = [
//     { id: 1, name: 'Altar Server', description: 'Assist during church services' },
//     { id: 2, name: 'Bookstore', description: 'Manage church bookstore operations' },
//     { id: 3, name: 'Check-in', description: 'Welcome and register attendees' },
//     { id: 4, name: 'Custodian', description: 'Maintain church facilities' },
//     { id: 5, name: 'Drummer', description: 'Provide musical accompaniment' },
//     { id: 6, name: 'Greeter', description: 'Welcome visitors and members' },
//     { id: 7, name: 'Greeter Assistant', description: 'Support greeting activities' },
//     { id: 8, name: 'Parking Lot', description: 'Direct traffic and parking' },
//     { id: 9, name: 'Pianist', description: 'Provide piano accompaniment' },
//     { id: 10, name: 'Sound Engineer', description: 'Manage audio equipment' },
//     { id: 11, name: 'Teacher', description: 'Lead educational programs' },
//     { id: 12, name: 'Usher', description: 'Guide seating and collections' },
//     { id: 13, name: 'Vestry', description: 'Church governance and leadership' }
// ]

const allSkills = ref([])

// const allUsers = [
//     { id: 2, name: 'Bookstore', description: 'Manage church bookstore operations' },
//     { id: 6, name: 'Greeter', description: 'Welcome visitors and members' },
//     { id: 13, name: 'Vestry', description: 'Church governance and leadership' }
// ]

// const currentAdmins = [
//     { id: 2, name: 'Bookstore', description: 'Manage church bookstore operations' },
//     { id: 6, name: 'Greeter', description: 'Welcome visitors and members' },
//     { id: 13, name: 'Vestry', description: 'Church governance and leadership' }
// ]

const allUsers = ref([])
const currentAdmins = ref([])
const organizationId = ref(null)
const setupStatus = ref(null)
const loadingSetupStatus = ref(false)

// ── Track unsaved changes for Save button pulse ──
const originalLocation = ref(null)
const hasChanges = computed(() => {
    if (!originalLocation.value) return false
    const orig = originalLocation.value
    const cur = location
    return orig.name !== cur.name
        || orig.description !== cur.description
        || orig.email !== cur.email
        || orig.phone !== cur.phone
        || orig.priority !== cur.priority
        || orig.status !== cur.status
        || orig.displayAds !== cur.displayAds
        || orig.displayMessages !== cur.displayMessages
        || orig.userRegister !== cur.userRegister
        || orig.allowVolunteerGroupCreation !== cur.allowVolunteerGroupCreation
        || orig.searchable !== cur.searchable
        || orig.viewSchedules !== cur.viewSchedules
        || orig.userpreferredoptions !== cur.userpreferredoptions
        || orig.enableReminders !== cur.enableReminders
        || orig.enable_ai_chat !== cur.enable_ai_chat
        || orig.enable_ai_schedulegeneration !== cur.enable_ai_schedulegeneration
        || orig.volunteerInvitesEnabled !== cur.volunteerInvitesEnabled
        || orig.monthly_ai_chat_cost_limit !== cur.monthly_ai_chat_cost_limit
        || orig.monthly_ai_schedulegeneration_cost_limit !== cur.monthly_ai_schedulegeneration_cost_limit
        || orig.monthly_sms_cost_limit !== cur.monthly_sms_cost_limit
        || orig.monthly_spend_limit !== cur.monthly_spend_limit
        || orig.autoScheduler !== cur.autoScheduler
        || orig.sendAdminReportDay !== cur.sendAdminReportDay
        || orig.timezone !== cur.timezone
        || orig.country !== cur.country
        || orig.defaultSkill !== cur.defaultSkill
        || orig.viewMode !== cur.viewMode
        || orig.sendSmsDays !== cur.sendSmsDays
        || JSON.stringify(orig.noEmailDays) !== JSON.stringify(cur.noEmailDays)
        || orig.websiteUrl !== cur.websiteUrl
        || orig.customUrl !== cur.customUrl
})

onMounted(async () => {
    loading.value = true;
    try {       
        const response = await store.dispatch("getLocationManagementInfo", locationId)
        publicLinkTokens.value = response?.public_link_tokens || null
        const response2 = await store.dispatch("fetchlocationDetails", locationId)

        console.log("response2", response2);
        
        store.dispatch("getCountries")
        store.dispatch("getTimezones")

        if (response?.admin_links?.links) {
            additionalPages.value = response.admin_links.links.map(link => ({
                name: link.title,
                description: link.description,
                url: link.url,
                id: link.id
            }))
        }

        var locationDetails = response.location_details.data

        console.log("locationDetails", locationDetails)
        
        // Store organization ID for API calls - check multiple possible locations
        organizationId.value = locationDetails.organizationid || 
                              locationDetails.organization_id || 
                              response.location?.organizationid ||
                              response.location?.organization_id ||
                              getOrganizationId() ||
                              store.getters.stSessionData?.organizationid
        
        // Debug: Log organization ID to console
        console.log('Organization ID extracted:', organizationId.value, 'from response:', {
            locationDetails: locationDetails,
            location: response.location,
            sessionOrgId: getOrganizationId(),
            storeOrgId: store.getters.stSessionData?.organizationid
        })

        allSkills.value = (locationDetails.skills || []).map(skill => ({
            value: skill.skillid,
            label: skill.skillname,
        }))

        viewModeOptions.value = (locationDetails.view_modes || []).map(mode => ({
            value: String(mode.value),
            label: mode.label
        }))

        allUsers.value = response.admins.all_users.map(user => ({
            id: user.personid,
            name: user.display_text,
            description: user.email
        }));

        currentAdmins.value = response.admins.current_admins.map(user => ({
            id: user.personid,
            name: user.display_text,
            description: user.email
        }));


        location.id = locationDetails.id
        location.name = locationDetails.name
        location.description = locationDetails.description
        location.email = locationDetails.email
        location.phone = locationDetails.phone
        location.priority = locationDetails.priority
        location.status = locationDetails.status
        location.displayAds = locationDetails.showads ? "yes" : "no"
        location.displayMessages = locationDetails.showinspirations ? "yes" : "no"
        location.userRegister = locationDetails.selfregister ? "yes" : "no"
        location.allowVolunteerGroupCreation = locationDetails.allow_volunteer_group_creation ? "yes" : "no"
        location.searchable = [false, 0, "0"].includes(locationDetails.searchable) ? "no" : "yes"
        location.viewSchedules = locationDetails.userscheduleview ? "yes" : "no"
        location.userpreferredoptions = (locationDetails.userpreferredoptions === "1" || locationDetails.userpreferredoptions === 1) ? "yes" : "no"
        location.enableReminders = locationDetails.reminders_enabled ? "yes" : "no"
        location.enable_ai_chat = response2.enable_ai_chat
        location.enable_ai_schedulegeneration = response2.enable_ai_schedulegeneration
        location.volunteerInvitesEnabled = ![false, 0, "0", "false"].includes(response2.volunteer_invites_enabled)
        location.monthly_ai_chat_cost_limit = response2.monthly_ai_chat_cost_limit ?? 30
        location.monthly_ai_schedulegeneration_cost_limit = response2.monthly_ai_schedulegeneration_cost_limit ?? 50
        location.monthly_sms_cost_limit = response2.monthly_sms_cost_limit ?? 50
        location.monthly_spend_limit = response2.monthly_spend_limit ?? 0
        location.autoScheduler = locationDetails.autoschedule_complete_adminalert ? "yes" : "no"
        location.sendAdminReport = locationDetails.send_admin_report ? "yes" : "no"
        location.sendAdminReportDay = locationDetails.send_admin_report_day || "Thursday"
        location.timezone = locationDetails.timezone   // was time_zone before
        location.country = locationDetails.country
        location.defaultSkill = locationDetails.default_skill ?? ""
        location.viewMode = String(locationDetails.default_view_mode ?? 0)
        location.sendSmsDays = locationDetails.smsdays ?? 0
        location.noEmailDays = locationDetails.exclude_email_days ?? []
        location.websiteUrl = locationDetails.location_url ?? ""
        location.customUrl = locationDetails.custom_url ?? ""
        location.loginUrl = locationDetails.custom_login_url ?? ""
        location.lastReportDate = locationDetails.last_admin_alert_dt ?? ""
        location.signUpContext = locationDetails.sign_up_context ?? ""

        // Snapshot for change detection
        originalLocation.value = { ...location, noEmailDays: [...location.noEmailDays] }
    }
    finally {
        loading.value = false;
    }
})

async function saveOrganization() {
    if (isSaving.value) return;
    
    // Validate email before saving
    validateEmail();
    if (emailError.value) {
        toast.error("Please fix validation errors before saving", { position: 'top-right' });
        return;
    }
    
    isSaving.value = true;
    try {
        // Prepend https:// to website URL if it has a value but no protocol
        let websiteUrl = location.websiteUrl || "";
        if (websiteUrl && !websiteUrl.startsWith('http://') && !websiteUrl.startsWith('https://')) {
            websiteUrl = 'https://' + websiteUrl;
        }

        const payload = {
            id: location.id,
            locationname: location.name,
            description: location.description,
            email: location.email,
            phone: location.phone,
            status: location.status,
            time_zone: location.timezone,
            country: location.country,
            priority: location.priority,
            showinspirations: location.displayMessages === "yes",
            selfregister: location.userRegister === "yes",
            allow_volunteer_group_creation: location.allowVolunteerGroupCreation === "yes",
            searchable: location.searchable === "yes",
            userscheduleview: location.viewSchedules === "yes",
            userpreferredoptions: location.userpreferredoptions === "yes",
            reminders_enabled: location.enableReminders === "yes",
            enable_ai_chat: location.enable_ai_chat,
            enable_ai_schedulegeneration: location.enable_ai_schedulegeneration,
            volunteer_invites_enabled: location.volunteerInvitesEnabled,
            monthly_ai_chat_cost_limit: location.monthly_ai_chat_cost_limit,
            monthly_ai_schedulegeneration_cost_limit: location.monthly_ai_schedulegeneration_cost_limit,
            monthly_sms_cost_limit: location.monthly_sms_cost_limit,
            monthly_spend_limit: location.monthly_spend_limit,
            autoschedule_complete_adminalert: location.autoScheduler === 'yes',
            send_admin_report: location.sendAdminReport === 'yes',
            send_admin_report_day: location.sendAdminReportDay,
            showads: location.displayAds === "yes",
            smsdays: location.sendSmsDays,
            location_url: websiteUrl,
            custom_url: location.customUrl || ""
        }

        const response = await store.dispatch("updateLocation", {
            id: location.id,
            payload
        });

        // Show API response message in toast
        const message = response?.output?.message || response?.message || "Location updated successfully";
        toast.success(message, { position: 'top-right' });
    } catch (error) {
        // Extract field-specific validation errors if available
        const validationErrors = error?.response?.data?.errors;
        if (validationErrors && typeof validationErrors === 'object') {
            const fieldErrors = Object.values(validationErrors).flat().join('; ');
            toast.error(fieldErrors, { position: 'top-right' });
        } else {
            const errorMessage = error?.response?.data?.output?.message || 
                                error?.response?.data?.message || 
                                error?.response?.data?.error ||
                                error?.message || 
                                "Failed to update location";
            toast.error(errorMessage, { position: 'top-right' });
        }
    }
    finally {
        isSaving.value = false;
    }
}

const countriesOptions = computed(() => {
    const countries = store.getters["stCountries"] || {}
    return Object.keys(countries).map(key => ({
        label: countries[key],
        value: key
    }))
})

const timezonesOptions = computed(() => {
    const zones = store.getters["stTimezones"] || {}
    return Object.keys(zones).map(key => ({
        label: zones[key],
        value: key
    }))
})

function validateEmail() {
    if (location.email && location.email.trim() !== '') {
        if (!isValidEmail(location.email)) {
            emailError.value = 'Please enter a valid email address';
        } else {
            emailError.value = null;
        }
    } else {
        emailError.value = null;
    }
}

function toggleDay(day) {
    if (location.noEmailDays.includes(day)) {
        location.noEmailDays = location.noEmailDays.filter(d => d !== day)
    } else {
        location.noEmailDays.push(day)
    }
}

function replacePlaceholders(value) {
    if (typeof value !== 'string') {
        return value;
    }
    return value
        .replace(/<locationid>/gi, locationId || '')
        .replace(/<personid>/gi, loggedPersonId.value || '');
}

// Map each card to different icon and color
function getCardIcon(name) {
    const iconMap = {
        "Add/Edit Users And Volunteers": {
            name: "people",
            color: "text-white",
            background: "info"
        },
        "Add/edit Users and Volunteers": {
            name: "people",
            color: "text-white",
            background: "info"
        },
        "Download Users List": {
            name: "download",
            color: "text-white",
            background: "success"
        },
        "Download Users list": {
            name: "download",
            color: "text-white",
            background: "success"
        },
        "Create/Edit Activities/Events": {
            name: "event",
            color: "text-white",
            background: "primary"
        },
        "Create/edit Activities/Events": {
            name: "event",
            color: "text-white",
            background: "primary"
        },
        "Create/Edit Skills/Roles": {
            name: "workspace_premium",
            color: "text-white",
            background: "warning"
        },
        "Create/edit Skills/Roles": {
            name: "workspace_premium",
            color: "text-white",
            background: "warning"
        },
        "Manage Schedules": {
            name: "calendar_today",
            color: "text-white",
            background: "info"
        },
        "Pending Registrations": {
            name: "pending_actions",
            color: "text-white",
            background: "warning"
        },
        "Send Message To Admins": {
            name: "email",
            color: "text-white",
            background: "success"
        },
        "Send Message to Admins": {
            name: "email",
            color: "text-white",
            background: "success"
        },
        "Activate DEMO": {
            name: "play_circle",
            color: "text-white",
            background: "danger"
        },
        "ACTIVITY SETUP WIZARD": {
            name: "settings",
            color: "text-white",
            background: "primary"
        },
        "Activity Setup Wizard": {
            name: "settings",
            color: "text-white",
            background: "primary"
        }
    };
    
    return iconMap[name] || {
        name: "weekend",
        color: "text-white",
        background: "dark"
    };
}

async function redirectToPage(item) {
    const url = item.url || item.link;
    console.log("url", url);
    const processedUrl = typeof url === 'string' ? replacePlaceholders(url) : url;

    // Check if it's a modal type (url can be an object with type and path)
    if (processedUrl && typeof processedUrl === 'object' && processedUrl.type === 'modal') {
        const modalPath = replacePlaceholders(processedUrl.path || '');
        if (!modalPath) {
            console.error('Modal path is empty', item);
            return;
        }
        openAdditionalModal(item.name || item.title || 'Details', modalPath);
        return;
    }

    // Legacy support: check item.type directly (for backward compatibility)
    if (item.type === 'modal') {
        const iframeTarget = typeof processedUrl === 'string' ? processedUrl : '';
        if (!iframeTarget) {
            console.error('Modal link is empty or not a string', item);
            return;
        }
        openAdditionalModal(item.name || item.title || 'Details', iframeTarget);
        return;
    }

    // Check if it's a JavaScript function call
    if (typeof processedUrl === 'string' && processedUrl.startsWith('javascript:')) {
        try {
            const jsCode = processedUrl.replace('javascript:', '').trim();
            const func = new Function(jsCode);
            func();
        } catch (error) {
            console.error('Error executing JavaScript:', error);
            if (window.$toast) {
                window.$toast.error('Error executing action: ' + error.message, { position: 'top-right' });
            } else {
                alert('Error executing action: ' + error.message);
            }
        }
        return;
    }
    
    // Check if it's an API call
    if (processedUrl && typeof processedUrl === 'object' && processedUrl.type === 'api') {
        try {
            const method = (processedUrl.method || 'POST').toUpperCase();
            const apiPath = processedUrl.path;
            const data = processedUrl.data || {};
            
            let response;
            if (method === 'POST') {
                response = await api.post(apiPath, data);
            } else if (method === 'GET') {
                response = await api.get(apiPath, { params: data });
            } else {
                throw new Error(`Unsupported HTTP method: ${method}`);
            }
            
            const contentType = response.headers['content-type'] || '';
            if (contentType.includes('application/octet-stream') || 
                contentType.includes('text/csv') || 
                contentType.includes('application/vnd.ms-excel')) {
                const blob = new Blob([response.data], { type: contentType });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'download';
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                } else {
                    if (data.cmd === 'getusers') {
                        filename = `users_${locationId}_${new Date().toISOString().split('T')[0]}.csv`;
                    }
                }
                
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
                
                if (window.$toast) {
                    window.$toast.success('File downloaded successfully', { position: 'top-right' });
                }
            } else {
                const responseData = response.data;
                if (window.$toast) {
                    const message = responseData.message || responseData.output?.message || 'Action completed successfully';
                    window.$toast.success(message, { position: 'top-right' });
                } else {
                    alert(responseData.message || responseData.output?.message || 'Action completed successfully');
                }
            }
        } catch (error) {
            console.error('API call error:', error);
            const errorMessage = error?.response?.data?.message || 
                                error?.message || 
                                'An error occurred while executing the action';
            
            if (window.$toast) {
                window.$toast.error(errorMessage, { position: 'top-right' });
            } else {
                alert(errorMessage);
            }
        }
        return;
    }
    
    if (typeof processedUrl === 'string' && (processedUrl.startsWith('http://') || processedUrl.startsWith('https://'))) {
        window.open(processedUrl, '_blank', 'noopener,noreferrer');
        return;
    }
    
    if (processedUrl && typeof processedUrl === 'object' && processedUrl.path) {
        const path = processedUrl.path;
        if (typeof path === 'string' && (path.startsWith('http://') || path.startsWith('https://'))) {
            window.open(path, '_blank', 'noopener,noreferrer');
            return;
        }
        router.push(path);
    } else if (typeof processedUrl === 'string') {
        if (processedUrl.startsWith('http://') || processedUrl.startsWith('https://')) {
            window.open(processedUrl, '_blank', 'noopener,noreferrer');
            return;
        }
        router.push(processedUrl);
    } else {
        console.error('Invalid URL format:', processedUrl);
        if (window.$toast) {
            window.$toast.error('Invalid link configuration', { position: 'top-right' });
        } else {
            alert('Invalid link configuration');
        }
    }
}

function goToEditOrganization() {
    if (organizationId.value) {
        router.push({ name: 'EditOrganization', params: { organizationID: organizationId.value } });
    }
}

function openAdditionalModal(title, url) {
    additionalModalHeading.value = title;
    additionalModalUrl.value = url;
    isAdditionalModalOpen.value = true;
}

function closeAdditionalModal() {
    isAdditionalModalOpen.value = false;
}

async function openModal() {
    showModal.value = true;
    loadingSetupStatus.value = true;
    setupStatus.value = null;
    
    try {
        setupStatus.value = await store.dispatch("fetchLocationSetupStatus", locationId);
        console.log("setupStatus.value", setupStatus.value);
        
    } catch (error) {
        console.error('Error fetching setup status:', error);
        toast.error('Failed to load setup status', { position: 'top-right' });
    } finally {
        loadingSetupStatus.value = false;
    }
}

// Handle saving selected admins from TagSelector
async function handleSaveInterests(selected) {
    console.log('handleSaveInterests called with:', selected);
    console.log('Current organizationId:', organizationId.value);
    
    if (!Array.isArray(selected)) {
        throw new Error("Invalid selection data");
    }
    
    currentAdmins.value = selected;
    
    // Extract user IDs from selected admins
    const userIds = selected.map(admin => admin.id).filter(id => id != null);
    console.log('Extracted user IDs:', userIds);
    
    // Call API to save admins
    if (!organizationId.value) {
        const errorMsg = "Organization ID not found. Cannot save admins.";
        console.error(errorMsg, 'Available data:', {
            locationId: locationId,
            location: location.value
        });
        toast.error(errorMsg, { position: 'top-right' });
        throw new Error(errorMsg);
    }
    
    const payload = {
        cmd: "saveadmins",
        locationid: locationId,
        adminids: userIds,
    };

    console.log("Calling API: /managelocationajax with payload:", payload);
    
    try {
        const response = await api.post("/managelocationajax", payload);
        console.log('API Response:', response);
        
        // Show API response message in toast
        const message = response?.data?.output?.message || response?.data?.message || "Admins saved successfully";
        
        toast.success(message, { position: 'top-right' });
        
        return response;
    } catch (error) {
        console.error('API Error:', error);
        const errorMessage = error?.response?.data?.message || 
                            error?.response?.data?.output?.message ||
                            error?.message || 
                            "Failed to save admins";
        
        toast.error(errorMessage, { position: 'top-right' });
        throw error;
    }
}

</script>

<style scoped>
/* ── Save button pulse ── */
@keyframes btn-pulse-glow {
    0%   { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.55); }
    70%  { box-shadow: 0 0 0 10px rgba(99, 102, 241, 0); }
    100% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0); }
}
.btn-pulse {
    animation: btn-pulse-glow 1.5s infinite;
}

.form-label {
    color: #7b809a;
}

.d-flex {
    display: flex;
}

.align-items-center {
    align-items: center;
}

.gap-2 {
    gap: 0.5rem;
}

/* Dashboard heading */
.dashboard-heading {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.25rem;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.dh-icon-wrap {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #fff;
}
.dh-icon-wrap i { font-size: 28px; }
.dh-icon-location { background: linear-gradient(135deg, #ef5350, #c62828); }
.dh-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 700;
    color: #344767;
}
.dh-subtitle {
    margin: 0;
    font-size: 0.78rem;
    color: #7b809a;
    margin-top: 2px;
}
.dh-nav-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.82rem;
    font-weight: 600;
    color: #667eea;
    cursor: pointer;
    text-decoration: none;
    padding: 6px 14px;
    border-radius: 8px;
    transition: background 0.15s, color 0.15s;
    white-space: nowrap;
}
.dh-nav-link:hover {
    background: #eef0ff;
    color: #4c63d2;
}

/* ── Monthly Cost Limits ── */
.cost-slider-row {
    padding: 12px 16px;
    border-radius: 10px;
    background: #f8f9fa;
}
.cost-slider-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 8px;
}
.cost-slider-label {
    font-weight: 600;
    font-size: 0.92rem;
    color: #344767;
    margin-bottom: 0;
}
.cost-slider-subtitle {
    font-size: 0.76rem;
    color: #7b809a;
    margin: 2px 0 0;
}
.cost-slider-value {
    font-weight: 700;
    font-size: 1.05rem;
    white-space: nowrap;
    min-width: 80px;
    text-align: right;
}
.cost-slider-value--blue   { color: #1976d2; }
.cost-slider-value--purple { color: #7b1fa2; }
.cost-slider-value--green  { color: #2e7d32; }
.cost-slider-value--orange { color: #ed6c02; }

.cost-slider-track-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
}
.cost-slider-minmax {
    font-size: 0.7rem;
    color: #adb5bd;
    flex-shrink: 0;
    width: 28px;
}
.cost-slider-minmax:last-child {
    text-align: right;
    width: 32px;
}

/* Base range slider */
.cost-slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 6px;
    border-radius: 3px;
    outline: none;
    background: #dee2e6;
}
/* Thumb — WebKit */
.cost-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 1px 4px rgba(0,0,0,0.25);
    cursor: pointer;
}
/* Thumb — Firefox */
.cost-slider::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 1px 4px rgba(0,0,0,0.25);
    cursor: pointer;
}
/* Track fill — Firefox */
.cost-slider::-moz-range-progress { border-radius: 3px; height: 6px; }

/* Blue variant */
.cost-slider--blue { accent-color: #1976d2; }
.cost-slider--blue::-webkit-slider-thumb { background: #1976d2; }
.cost-slider--blue::-moz-range-thumb     { background: #1976d2; }
.cost-slider--blue::-moz-range-progress  { background: #1976d2; }

/* Purple variant */
.cost-slider--purple { accent-color: #7b1fa2; }
.cost-slider--purple::-webkit-slider-thumb { background: #7b1fa2; }
.cost-slider--purple::-moz-range-thumb     { background: #7b1fa2; }
.cost-slider--purple::-moz-range-progress  { background: #7b1fa2; }

/* Green variant */
.cost-slider--green { accent-color: #2e7d32; }
.cost-slider--green::-webkit-slider-thumb { background: #2e7d32; }
.cost-slider--green::-moz-range-thumb     { background: #2e7d32; }
.cost-slider--green::-moz-range-progress  { background: #2e7d32; }

/* Orange variant */
.cost-slider--orange { accent-color: #ed6c02; }
.cost-slider--orange::-webkit-slider-thumb { background: #ed6c02; }
.cost-slider--orange::-moz-range-thumb     { background: #ed6c02; }
.cost-slider--orange::-moz-range-progress  { background: #ed6c02; }
</style>
